/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Table_PropertyInputs */

const en_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Property`)
};

const fr_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriété de métadonnées`)
};

const de_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten-Eigenschaft`)
};

const it_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietà dei metadati`)
};

const ru_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свойство метаданных`)
};

const es_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedad de metadatos`)
};

const zh_cn2_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据属性`)
};

const ja_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータプロパティ`)
};

const hi_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा प्रॉपर्टी`)
};

const pt_pt2_event_group_metadata_table_property = /** @type {(inputs: Event_Group_Metadata_Table_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedade de metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Property" |
*
* @param {Event_Group_Metadata_Table_PropertyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_table_property = /** @type {((inputs?: Event_Group_Metadata_Table_PropertyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Table_PropertyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_table_property(inputs)
	if (locale === "de") return de_event_group_metadata_table_property(inputs)
	if (locale === "it") return it_event_group_metadata_table_property(inputs)
	if (locale === "ru") return ru_event_group_metadata_table_property(inputs)
	if (locale === "es") return es_event_group_metadata_table_property(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_table_property(inputs)
	if (locale === "ja") return ja_event_group_metadata_table_property(inputs)
	if (locale === "hi") return hi_event_group_metadata_table_property(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_table_property(inputs)
	return en_event_group_metadata_table_property(inputs)
});